import useCountUp from "@/hooks/useCountUp";
import useReveal from "@/hooks/useReveal";

const stats = [
  { icon: "ri-time-line", label: "시공경력", value: 16, suffix: "년+" },
  { icon: "ri-building-2-line", label: "시공현장", value: 400, suffix: "건" },
  { icon: "ri-government-line", label: "공공기관 시공", value: 128, suffix: "건" },
  { icon: "ri-thumb-up-line", label: "고객만족도", value: 98, suffix: "%" },
  { icon: "ri-team-line", label: "전문 시공인력", value: 42, suffix: "명" },
];

function StatCard({
  icon,
  label,
  value,
  suffix,
}: {
  icon: string;
  label: string;
  value: number;
  suffix: string;
}) {
  const { ref, value: v } = useCountUp(value);
  return (
    <div
      ref={ref}
      className="relative p-5 md:p-8 lg:p-10 border border-white/10 rounded-2xl hover:bg-white/5 transition-all duration-500 ease-out hover:-translate-y-2"
    >
      <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-point-500/15 text-point-400 mb-4 md:mb-6">
        <i className={`${icon} text-xl md:text-2xl`}></i>
      </div>
      <div className="font-hero text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl tabular-nums leading-none">
        {v}
        <span className="text-point-400 ml-1 text-xl sm:text-2xl md:text-3xl lg:text-4xl">{suffix}</span>
      </div>
      <div className="mt-3 md:mt-4 text-white/60 text-xs md:text-sm uppercase tracking-widest">
        {label}
      </div>
    </div>
  );
}

export default function WhyUs() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section className="relative w-full py-24 md:py-32 bg-navy-950 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Massive%20industrial%20factory%20interior%20at%20dusk%20with%20dramatic%20orange%20sunset%20light%20streaming%20through%20windows%2C%20clean%20polished%20epoxy%20floor%20reflecting%20warm%20light%2C%20cinematic%20wide%20perspective%2C%20premium%20architectural%20photography%2C%20muted%20dark%20navy%20tone%20with%20orange%20accent%2C%20minimalist%20composition%2C%20high%20end%20editorial%20atmosphere%2C%20soft%20haze%20in%20the%20air&width=1920&height=1080&seq=jinc-whyus-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/85 to-navy-950"></div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-px bg-point-500"></span>
            <span className="text-point-400 text-xs font-semibold uppercase tracking-[0.3em]">
              Why JI&amp;C
            </span>
          </div>
          <h2 className="font-hero text-white text-3xl md:text-5xl lg:text-6xl leading-tight mb-6">
            숫자로 증명하는
            <br />
            <span className="text-point-400">현장의 실력</span>
          </h2>
          <p className="text-white/70 text-base md:text-lg leading-relaxed">
            16년간 축적된 실전 데이터. 제이아이앤씨는 말이 아닌 완공된 현장으로
            증명해온 전문건설업체입니다.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6">
          {stats.map((s) => (
            <StatCard key={s.label} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}